import { render, staticRenderFns } from "./sonList.vue?vue&type=template&id=72bc8273&scoped=true&"
import script from "./sonList.vue?vue&type=script&lang=js&"
export * from "./sonList.vue?vue&type=script&lang=js&"
import style0 from "./sonList.vue?vue&type=style&index=0&id=72bc8273&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bc8273",
  null
  
)

export default component.exports